export default function buildGeocodeParams (search) {
    return {
        place_id: search.place_id,
    }
}
